import { Routes, Route, useLocation } from 'react-router-dom';
import { Container, Box, useMediaQuery, useTheme } from '@mui/material';

import { WalletProvider } from './hooks/useWallet';
import { SolanaWalletProvider } from './hooks/useSolanaWallet';
import { TronWalletProvider } from './hooks/useTronWallet';
import Header from './components/Header';
import Sidebar, { SIDEBAR_WIDTH } from './components/Sidebar';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Deposit from './pages/Deposit';
import History from './pages/History';
import Docs from './pages/Docs';
import PitchDeck from './pages/PitchDeck';
import TechnicalPaper from './pages/TechnicalPaper';
import WithdrawV2 from './pages/WithdrawV2';
import Leaderboard from './pages/Leaderboard';
import EasyMode from './pages/EasyMode';
import Faucet from './pages/Faucet';
import Guide from './pages/Guide';

function App() {
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isLanding = location.pathname === '/';
  const isDocs = location.pathname === '/docs';
  const isPitchDeck = location.pathname === '/pitch-deck';
  const isTechnicalPaper = location.pathname === '/technical-paper';

  const useStandardLayout = !isLanding && !isDocs && !isPitchDeck && !isTechnicalPaper;

  return (
    <SolanaWalletProvider>
      <WalletProvider>
       <TronWalletProvider>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: useStandardLayout ? 'background.default' : 'transparent',
            background: useStandardLayout ? 'background.default' : 'transparent',
          }}
        >
          {useStandardLayout && <Header />}

          <Routes>
            {/* Full-page routes that manage their own layout */}
            <Route path="/" element={<Landing />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/pitch-deck" element={<PitchDeck />} />
            <Route path="/technical-paper" element={<TechnicalPaper />} />

            {/* All standard routes get sidebar layout */}
            <Route
              path="/*"
              element={
                <Box sx={{ display: 'flex', flex: 1 }}>
                  {useStandardLayout && <Sidebar />}
                  <Box
                    sx={{
                      flex: 1,
                      ml: useStandardLayout && isDesktop ? `${SIDEBAR_WIDTH}px` : 0,
                      transition: 'margin-left 0.2s',
                      minWidth: 0,
                    }}
                  >
                    <Container maxWidth="lg" sx={{ py: { xs: 1.5, md: 3 }, px: { xs: 1, md: 3 } }}>
                      <Routes>
                        <Route path="/easy" element={<EasyMode />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/deposit" element={<Deposit />} />
                        <Route path="/withdraw-v2" element={<WithdrawV2 />} />
                        <Route path="/faucet" element={<Faucet />} />
                        <Route path="/history" element={<History />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/guide" element={<Guide />} />
                      </Routes>
                    </Container>
                  </Box>
                </Box>
              }
            />
          </Routes>
        </Box>
       </TronWalletProvider>
      </WalletProvider>
    </SolanaWalletProvider>
  );
}

export default App;
